import { PatchNotesDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderPatchNotesDialog = mountDialogUIReactComponent(PatchNotesDialog);
// TODO: Muhammad - Map client patch notes to UI patch note structure; make this a boundry point
export const showPatchNotesDialog = (props)=>{
    renderPatchNotesDialog(props);
};
